var styles = {"box":"WalletTabs_box_17e84_1","left":"WalletTabs_left_17e84_7","right":"WalletTabs_right_17e84_16","tabs":"WalletTabs_tabs_17e84_20","tabs__list":"WalletTabs_tabs__list_17e84_23","panel":"WalletTabs_panel_17e84_40","visible":"WalletTabs_visible_17e84_48","scroll-tabs-container":"WalletTabs_scroll-tabs-container_17e84_59","tab":"WalletTabs_tab_17e84_20"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
